<template>
    <div>
        <!-- <div class="h5">{{ t.checkout.personal_details }}</div> -->
        <form @submit.prevent="savePersonalDetails" @keydown="formPersonalDetails.onKeydown($event)">
            <div class="row" v-if="config.customer_name_fields == 2">
                <div class="col-md-6 mb-3">
                    <label for="first_name">{{ t.personal_details.first_name}}<span class="small text-danger">*</span></label>
                    <input v-model="formPersonalDetails.first_name" type="text" class="form-control" id="first_name" name="first_name" :disabled="formPersonalDetails.busy">
                    <div class="small text-danger" v-if="formPersonalDetails.errors.has('first_name')" v-html="formPersonalDetails.errors.get('first_name')"></div>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="last_name">{{ t.personal_details.last_name}}<span class="small text-danger">*</span></label>
                    <input v-model="formPersonalDetails.last_name" type="text" class="form-control" id="last_name" name="last_name" :disabled="formPersonalDetails.busy">
                    <div class="small text-danger" v-if="formPersonalDetails.errors.has('last_name')" v-html="formPersonalDetails.errors.get('last_name')"></div>
                </div>
            </div>
            <div v-else>
                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label for="name">{{ t.personal_details.name}}<span class="small text-danger">*</span></label>
                        <input v-model="formPersonalDetails.name" type="text" class="form-control" id="name" name="name" :disabled="formPersonalDetails.busy">
                        <div class="small text-danger" v-if="formPersonalDetails.errors.has('name')" v-html="formPersonalDetails.errors.get('name')"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="email">{{ t.personal_details.email}}<span class="small text-danger">*</span></label>
                    <input v-model="formPersonalDetails.email" type="email" class="form-control" id="email" name="email" :disabled="formPersonalDetails.busy">
                    <div class="small text-danger" v-if="formPersonalDetails.errors.has('email')" v-html="formPersonalDetails.errors.get('email')"></div>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="phone">{{ t.personal_details.phone}}<span class="small text-danger">*</span></label>
                    <input v-model="formPersonalDetails.phone" type="text" class="form-control" id="phone" name="phone" :disabled="formPersonalDetails.busy">
                    <div class="small text-danger" v-if="formPersonalDetails.errors.has('phone')" v-html="formPersonalDetails.errors.get('phone')"></div>
                </div>
            </div>
            <div class="mb-3">
                <div class="cursor-pointer" @click="showCompanyInfo ? showCompanyInfo = false : showCompanyInfo = true">{{ t.checkout.show_company_info}} ({{ t.global.optional}})<i class="ms-2 fa" :class="{'fa-chevron-down': showCompanyInfo, 'fa-chevron-right': !showCompanyInfo}"></i></div>
                <transition name="fade">
                    <div class="row mt-3" v-if="showCompanyInfo">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label for="company_name">{{ t.personal_details.company_name}} ({{ t.global.optional}})</label>
                                <input v-model="formPersonalDetails.company_name" type="text" class="form-control" id="company_name" name="company_name" :disabled="formPersonalDetails.busy">
                                <div class="small text-danger" v-if="formPersonalDetails.errors.has('company_name')" v-html="formPersonalDetails.errors.get('company_name')"></div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label for="tax_number">{{ t.personal_details.tax_number}} ({{ t.global.optional}})</label>
                                <input v-model="formPersonalDetails.tax_number" type="text" class="form-control" id="tax_number" name="tax_number" :disabled="formPersonalDetails.busy">
                                <div class="small text-danger" v-if="formPersonalDetails.errors.has('tax_number')" v-html="formPersonalDetails.errors.get('tax_number')"></div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
            <div class="h5 mb-2">{{ t.shipping_details.address }}</div>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="street">{{ t.shipping_details.street}}<span class="small text-danger">*</span></label>
                    <input v-model="formPersonalDetails.street" type="text" class="form-control" id="street" name="street" :disabled="formPersonalDetails.busy">
                    <div class="small text-danger" v-if="formPersonalDetails.errors.has('street')" v-html="formPersonalDetails.errors.get('street')"></div>
                </div>
                <div class="col-md-6 mb-3">
                    <label for="zip_code">{{ t.shipping_details.zip_code}}<span class="small text-danger">*</span></label>
                    <input v-model="formPersonalDetails.zip_code" type="text" class="form-control" id="zip_code" name="zip_code" :disabled="formPersonalDetails.busy">
                    <div class="small text-danger" v-if="formPersonalDetails.errors.has('zip_code')" v-html="formPersonalDetails.errors.get('zip_code')"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 mb-3">
                    <label for="city">{{ t.shipping_details.city }}<span class="text-danger">*</span></label>
                    <input type="text" name="city" id="city" class="form-control" v-model="formPersonalDetails.city" :disabled="formPersonalDetails.busy" />
                    <div class="small text-danger" v-if="formPersonalDetails.errors.has('city')"
                        v-html="formPersonalDetails.errors.get('city')"></div>
                </div>
                <div class="col-md-6 mb-3" v-if="!config.default_country">
                    <label for="country">{{ t.shipping_details.country }}<span class="text-danger">*</span></label>
                    <select class="form-select" name="country" id="country" v-model="formPersonalDetails.country" :disabled="formPersonalDetails.busy">
                        <option value=""></option>
                        <option v-for="(countryName, countryCode) in country_list" :value="countryCode">{{ countryName }}
                        </option>
                    </select>
                    <div class="small text-danger" v-if="formPersonalDetails.errors.has('country')"
                        v-html="formPersonalDetails.errors.get('country')"></div>
                </div>
            </div>
            <div v-if="!user || !user.id">
                <div class="h5 mb-2">{{ t.account.account }}</div>
                <div>
                    <label class="mb-0" for="create_account"><input v-model="formPersonalDetails.create_account" type="checkbox" name="create_account" id="create_account" :disabled="formPersonalDetails.busy"> {{ t.checkout.create_account}}</label>
                </div>
                <div class="text-muted mb-2">({{ t.checkout.already_have_account}}, <a class="cursor-pointer text-underline text-lowercase" href="login?url=checkout.form">{{ t.global.log_in}}</a>)</div>
                <transition name="fade">
                    <div v-if="formPersonalDetails.create_account" class="mb-3">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label for="password">{{ t.personal_details.password}}<span class="small text-danger">*</span></label>
                                <input v-model="formPersonalDetails.password" type="password" class="form-control" id="password" name="password" :disabled="formPersonalDetails.busy">
                                <div class="small text-danger" v-if="formPersonalDetails.errors.has('password')" v-html="formPersonalDetails.errors.get('password')"></div>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="password_confirmation">{{ t.personal_details.password_confirmation}}<span class="small text-danger">*</span></label>
                                <input v-model="formPersonalDetails.password_confirmation" type="password" class="form-control" id="password_confirmation" name="password_confirmation" :disabled="formPersonalDetails.busy">
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
            <input v-model="formPersonalDetails.prospect_consent" type="checkbox" name="prospect_consent" id="prospect_consent" class="me-2" :disabled="formPersonalDetails.busy"><label class="mb-0" for="prospect_consent">{{ t.personal_details.prospect_consent}}</label>
            <div class="text-muted" v-if="config.modules.gdpr">*{{ t.account.info_collect_personal_data }}</div>
            <div class="mt-3">
                <button class="btn btn-primary" type="submit" :disabled="formPersonalDetails.busy">{{ t.checkout.next_step}}</button>
            </div>
        </form>
    </div>
</template>

<script>
import Form from 'vform'
export default {
    data() {
        return Object.assign({
            formPersonalDetails: new Form({
                first_name: this.$attrs.user ? this.$attrs.user.customer.first_name : '',
                last_name: this.$attrs.user ? this.$attrs.user.customer.last_name : '',
                name: this.$attrs.user ? this.$attrs.user.customer.name : '',
                email: this.$attrs.user ? this.$attrs.user.email : '',
                phone: this.$attrs.user ? this.$attrs.user.customer.phone : '',
                street: this.$attrs.user ? this.$attrs.user.customer.street : '',
                zip_code: this.$attrs.user ? this.$attrs.user.customer.zip_code : '',
                city: this.$attrs.user ? this.$attrs.user.customer.city : '',
                country: this.$attrs.user ? this.$attrs.user.customer.country : '',
                company_name: this.$attrs.user ? this.$attrs.user.customer.company_name : '',
                tax_number: this.$attrs.user ? this.$attrs.user.customer.tax_number : '',
                create_account: this.$attrs.user ? false : true,
                password: '',
                password_confirmation: '',
                prospect_consent: true,
            }),
            showCompanyInfo: this.$attrs.user && (this.$attrs.user.customer.company_name || this.$attrs.user.customer.tax_number) ? true : false,
            country_list: window.country_list,
        }, this.$attrs)
    },
    methods: {
        async savePersonalDetails () {
            const response = await this.formPersonalDetails.post(this.url('ajax/checkout/personal-details'))
            if (response.data.success) {
                this.$listeners.goToNextStep()
                if (response.data.message) {
                    this.notify({text: response.data.message, type: 'success'})
                }
                if (response.data.user) {
                    this.$listeners.updateUser(response.data.user)
                }
            }
        },
    }
}
</script>
